module.exports = __webpack_public_path__ + "img/footer_weibo.de8ff072.png";